import loadable from '@loadable/component';

const NewsPage = loadable(() => import('./page'));
const NewsArticlePage = loadable(() => import('./[id]/page'));
const NewsResearchPage = loadable(() => import('./[id]/research/page'));

export const routes = [
  {
    path: '',
    element: <NewsPage />,
  },
  {
    path: ':id',
    element: <NewsArticlePage />,
  },
  {
    path: ':id/research',
    element: <NewsResearchPage />,
  },
];
